import SalesMenuType from './SalesMenuType';

export default SalesMenuType;
